import React from 'react';
import { Link } from 'react-router-dom';
import { serviciosData } from '../data/mock';

const Servicios = () => {
  return (
    <section id="servicios" className="py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-10 max-w-7xl">
        {/* Services Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-5">
          {serviciosData.map((servicio) => (
            <Link
              key={servicio.id}
              to={`/servicios/${servicio.slug}`}
              data-testid={`servicio-card-${servicio.slug}`}
              className="group bg-white rounded-lg overflow-hidden border border-gray-200 hover:border-[#0d3b66] hover:shadow-lg transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={servicio.imagen}
                  alt={servicio.nombre}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="font-semibold text-gray-900 text-base mb-1 group-hover:text-[#0d3b66] transition-colors">
                  {servicio.nombre}
                </h3>
                <p className="text-gray-500 text-sm">
                  {servicio.descripcion}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servicios;
